import type { IRynReplayGridSnapshotsConfig } from './ryn-replay-grid-snapshots.config';

/**
 * Sparta blocked-grid snapshot registry (#31398).
 *
 * Single source for page ids, titles, routes, pause hosts, and early-load
 * fallback columns. Import once from `AppModule` via
 * `provideRynReplayGridSnapshots(WEB_SPARTA_RYN_REPLAY_GRID_SNAPSHOTS)`.
 *
 * Do not copy page entries into feature folders or duplicate them in the player.
 */
export const WEB_SPARTA_RYN_REPLAY_GRID_SNAPSHOTS: IRynReplayGridSnapshotsConfig =
  {
    app: 'web-sparta',
    pages: [
      {
        id: 'equipment-usage',
        title: 'Equipment Usage',
        routeIncludes: 'equipment-usage-page',
        hostSelector: 'ups-equipment-usage-page',
        pauseWhilePresent: true,
        pauseOnFocus: true,
        requireField: 'EquipmentDispatchID',
        // Equipment Usage holds no personal data (names, SSN), so its data
        // columns replay as-is (Mel Flores, PR 3797). Any column not listed,
        // including ones added to the grid later, stays masked.
        unmaskedColumns: [
          'Equipment',
          'EquipmentName',
          'WorkOrder',
          'AltID',
          'UnitName',
          'Shift',
          'TotalAmount',
          'Details',
        ],
        metaKeys: ['jobId', 'jobName', 'mode', 'dateStart', 'dateEnd'],
        fallbackColumns: [
          { key: 'Equipment', label: 'Equipment' },
          { key: 'EquipmentName', label: 'Name' },
          { key: 'WorkOrder', label: 'Work Order' },
          { key: 'AltID', label: 'Alt ID' },
          { key: 'UnitName', label: 'Unit' },
          { key: 'Shift', label: 'Shift', align: 'right', format: 'number' },
          {
            key: 'TotalAmount',
            label: 'Amount',
            align: 'right',
            format: 'number',
          },
          {
            key: 'Details',
            label: 'Details',
            align: 'right',
            format: 'number',
          },
        ],
      },
    ],
  };
